exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bet.button__container{position:absolute}.bet.button__container.landscape{top:446.83333px;left:1130px}.bet.button__container.landscape.inverted{left:auto;right:1232px}.bet.button__container.landscape.bet_interface_open{visibility:hidden}.bet.button__container.portrait{-webkit-transform-origin:top left;transform-origin:top left;width:80px;height:80px;left:50%;margin-left:85px;top:20%}.bet.button__container.portrait.inverted{margin-left:-165px;-webkit-transform-origin:top right;transform-origin:top right}", ""]);

// exports
exports.locals = {
	"bet": "bet",
	"button__container": "button__container",
	"buttonContainer": "button__container",
	"landscape": "landscape",
	"inverted": "inverted",
	"bet_interface_open": "bet_interface_open",
	"betInterfaceOpen": "bet_interface_open",
	"portrait": "portrait"
};